import defaultAttributes from '../defaultAttributes';

const ChevronLast = [
  'svg',
  defaultAttributes,
  [['polyline', { points: '7 18 13 12 7 6' }], ['path', { d: 'M17 6v12' }]],
];

export default ChevronLast;
